var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-view"},[_c('title-bar',{attrs:{"title-stack":_vm.titleStack}}),(_vm.user)?_c('section',{staticClass:"section is-main-section"},[_c('user',{staticClass:"mg-b",attrs:{"initialUser":_vm.user}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }